import React from 'react'
import { buildMParticleGlobalProperties, useInternalAnalytics } from '.'
import type { PageConfig } from 'models/pages'

// * mParticle logPageView event
export const useMParticleLogPageView = (pageConfig: PageConfig, loggedInState: boolean) => {
  const { mParticle, consentSynced } = useInternalAnalytics()
  const hasLoggedPageView = React.useRef(false)

  React.useEffect(() => {
    if (!mParticle || !consentSynced || hasLoggedPageView.current) return

    const globalProperties = buildMParticleGlobalProperties(pageConfig, mParticle, loggedInState)

    // * MParticle PageView Test
    mParticle.logPageView(
      'Page',
      {
        page_referrer: document.referrer,
        ...globalProperties,
        // * override surface with when in test treatment
      },
      {
        'GA4.Title': document.title,
        'GA4.Location': document.location.href,
        'GA4.Referrer': document.referrer,
      },
    )

    hasLoggedPageView.current = true
  }, [consentSynced, loggedInState, mParticle, pageConfig])
}
